import useLocaleNavigate from "hooks/reactRouterWrappers/useLocaleNavigate";
import { useTranslation } from "react-i18next";
import { setIdentifier, setLoginRedirect } from "redux/auth/authSlice";
import { useDispatch, useSelector } from "redux/hooks";
import { COOKIE_CUSTOMER_IDENTIFIER } from "utilities/consts";
import PathTranslationKey from "utilities/paths";
import { setAppCookie } from "utilities/cookies";

import useCartOnLogin from "hooks/cart/useCartOnLogin";


export type CustomerIdentifierType = {
	storeHash: string;
	token: string;
};

const useLogin = () => {
	const { t } = useTranslation();
	const { store } = useSelector((state) => state.bcStore);

	const dispatch = useDispatch();
	const navigate = useLocaleNavigate();

	const loginRedirect = useSelector((state) => state.auth.loginRedirect);

  	const { fetchCart } = useCartOnLogin();


	const doLogin = async (data: any) => {

		const cookie = data.cookie;


		const customerId = data.customer.id;

		const expiresDate = new Date(cookie.expires * 1000); //covert from s to ms
		
		await setAppCookie(cookie.name, cookie.value, () => expiresDate);

		const customerIdentifier = {
			storeHash: store?.hash,
			token: data.customer.identifier,
		} as CustomerIdentifierType;

		await setAppCookie(
			COOKIE_CUSTOMER_IDENTIFIER,
			JSON.stringify(customerIdentifier),
			() => expiresDate,
		);

		dispatch(setIdentifier(customerIdentifier));

    	await fetchCart(customerId, store?.hash || "");

		if (loginRedirect) {
			dispatch(setLoginRedirect(undefined));
			navigate(loginRedirect);
		} else {
			navigate(t(PathTranslationKey.ACCOUNT_OVERVIEW).toString());
		}
	};

	return (data: any) => {
		doLogin(data);
	};
};

export default useLogin;
